import Main from "./Main";

export default function App() {
  return (
    <Main></Main>
  )
}
